import Lenis from "lenis";
import { ReactNode, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "../../lib/motion";

gsap.registerPlugin(ScrollTrigger);

const SmoothScrollProvider = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    const reducedMotion = prefersReducedMotion();
    const usesCompactLayout = window.matchMedia("(max-width: 767px)").matches;

    if (reducedMotion || usesCompactLayout) {
      return;
    }

    const lenis = new Lenis({
      anchors: {
        duration: 1.2,
        offset: -112,
      },
      duration: 1.05,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 0.9,
    });

    const updateScrollTriggers = () => ScrollTrigger.update();
    const raf = (time: number) => lenis.raf(time * 1000);

    lenis.on("scroll", updateScrollTriggers);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);

    return () => {
      lenis.off("scroll", updateScrollTriggers);
      gsap.ticker.remove(raf);
      lenis.destroy();
    };
  }, []);

  return <>{children}</>;
};

export default SmoothScrollProvider;
